import { DeleteOutlined, FormOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons'
import { Alert, Button, Card, Input, Modal, Table } from 'antd'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ItemResponseRetargetingListBeanObject, ListPagination, RetargetingListBean } from 'src/api/api'
import { StorageKey, storageReaderFactory, storageWriterFactory } from 'src/util/Storage'
import { toSort, useSorter } from 'src/util/useSorter'
import retargetingListApi from './RetargetingListApi'
import { useDebounce } from 'src/util/useDebounce'

const Column = Table.Column

const storageWriter = storageWriterFactory('retargetingList')
const storageReader = storageReaderFactory('retargetingList')

interface Props { }

const RetargetingLists: React.FC<Props> = () => {

    const [data, setData] = useState<RetargetingListBean[]>([])
    const [pagination, setPagination] = useState<any>({
        defaultCurrent: 1,
        defaultPageSize: 10,
        current: 1
    })
    const [error, setError] = useState()

    const remove = (record: RetargetingListBean) => {
        Modal.confirm({
            title: `Delete ${record.name}?`,
            content: 'Are you sure?',
            cancelText: 'NO',
            okText: 'Yes, I\'m sure',
            onOk: async () => {
                try {
                    await retargetingListApi.delete(record.id as number)

                    let page = pagination.current
                    if (data.length == 1 && pagination.current > 1) {
                        page -= 1
                    }

                    loadData(page)
                } catch (e) {
                    setError(e.error)
                }
            }
        })
    }

    const [search, setSearch] = useState<string>()
    const debouncedSearch = useDebounce(search, 500)

    const loadData = async (page: number) => {

        const response = await retargetingListApi.list(pagination.defaultPageSize, page, toSort(sorter), search)

        const array = response.data as Array<ItemResponseRetargetingListBeanObject>
        const beans: RetargetingListBean[] = array.map(item => item.data as RetargetingListBean)

        if (beans.length == 0 && page > 1) {
            loadData(page - 1)
        } else {
            const newPagination: ListPagination = response.pagination as ListPagination
            storageWriter.write(StorageKey.SearchParams, {
                page: newPagination.currentPage
            })

            setData(beans)
            setPagination({ ...pagination, total: newPagination.total, current: newPagination.currentPage })
        }
    }

    const { sorter, handleTableChange } = useSorter(pagination, loadData)

    useEffect(() => {
        const searchParams = storageReader.read(StorageKey.SearchParams)
        const page = searchParams.page || pagination.current

        loadData(page)
    }, [debouncedSearch, sorter])

    return <Card
        title="Retargeting List"
        className="list-card"
        extra={<Link to={`/retargeting-list/create`} className="create-new-link">
            <Button type="primary" htmlType="button" icon={<PlusOutlined />}>
                New Retargeting List
            </Button>
        </Link>}
    >
        {error && <Alert message={error} type="error" />}
        <div className="list-filter-group">
            <Input prefix={<SearchOutlined />} placeholder="Search by ID, Name" onChange={e => setSearch(e.target.value || undefined)} />
        </div>
        <Table
            rowKey="id"
            size="middle"
            dataSource={data}
            pagination={{ ...pagination, size: 'default' }}
            onChange={handleTableChange}
        >
            <Column key="id" title="ID" dataIndex="id" sorter />
            <Column key="name" title="Name" dataIndex="name" sorter render={(text, record: RetargetingListBean) => <Link to={`/retargeting-list/${record.id}/edit`}>{text}</Link>} />
            <Column key="modified" title="Last Modified" dataIndex="modified" sorter />
            <Column align="center" key="action" title="Actions" render={(text: string, record: RetargetingListBean) =>
                <span>
                    <Link to={`/retargeting-list/${record.id}/edit`}>
                        <Button type="text">
                            <FormOutlined className="actions-btn" />
                        </Button>
                    </Link>
                    <Button type="text" danger onClick={() => remove(record)}>
                        <DeleteOutlined />
                    </Button>
                </span>
            } />
        </Table>
    </Card>
}

export default RetargetingLists



// WEBPACK FOOTER //
// ./src/component/app/retargetingList/RetargetingLists.tsx